import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { isPresent, isBlank } from '@seedlang/utils';
import Text from 'components/text';
import Alert from 'components/alert';
import { AppUI, VocabUI } from '@seedlang/state';
import Button from 'components/button/button';
import InPlaceSelect from 'components/form/in_place_select';
import { Constants, Theme } from '@seedlang/constants';
import InPlaceText from 'components/form/in_place_text';
import SeedlangExplainer from './seedlang_explainer';

const Wrapper = styled.div`
`;

const ReviewOptionsWrapper = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 10px 0 0 0;
  margin-bottom: 10px;
  position: relative;
  border: ${props => props.blueBorder ? `4px solid ${Theme.blue}` : 'none'};
  border-radius: ${props => props.blueBorder ? '12px' : '0'};
  input {
    height: 30px!important;
    width: calc(100% - 40px)!important;
    margin-left: 20px;
  }
  position: relative;
`;

export const AbsoluteContainer = styled.div`
  position: absolute;
  inset: 0;
  width: fit-content;
  height: fit-content;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const SeedlangDisclaimer = styled.div`
  background: #1DB5D7;
  border-radius: 0 0 12px 0;
  padding: 10px;
`;

@observer
class AddToReviews extends React.Component {

  static defaultProps = {
    confirmationMessage: 'Your reviews were successfully created.',
  };

  render() {
    return (
      <Wrapper>
        {
          this.props.showReviewsCreatedMessage &&
            <Alert
              textAlign='center'
              width='100%'
            >
              <div dangerouslySetInnerHTML={{ __html: this.props.confirmationMessage }} />
            </Alert>
        }
        {
          isPresent(this.props.selectedWordIds) && isBlank(this.props.reviewDeckOptions) &&
          <ReviewOptionsWrapper blueBorder={!AppUI.siteIsDefault}>
            {
                !AppUI.siteIsDefault &&
                  <SeedlangExplainer />
            }
            <Text
              fontSize='12px'
              bold
              margin='10px 0 0 0'
              color='#333'
            >
              Review Deck
            </Text>
            <InPlaceText
              allowUpdate
              show
              placeholder='Review Deck Name'
              defaultValue={VocabUI.newReviewDeckName}
              onChange={val => VocabUI.onSetNewReviewDeckName(val)}
            />
            <Button
              margin='10px 0 10px 0'
              onClick={() => VocabUI.onCreateNewReviewDeck(AppUI.loadReviewDecks)}
              disabled={isBlank(VocabUI.newReviewDeckName)}
            >
              <i className='fa fa-plus'/>
              Create Review Deck
            </Button>
          </ReviewOptionsWrapper>
        }
        {
          isPresent(this.props.selectedWordIds) && isPresent(this.props.reviewDeckOptions) &&
            <ReviewOptionsWrapper blueBorder={!AppUI.siteIsDefault}>
              {
                !AppUI.siteIsDefault &&
                  <SeedlangExplainer />
              }
              <Text
                fontSize='12px'
                bold
                margin='10px 0 0 0'
                color='#333'
              >
                Review Deck
              </Text>
              <InPlaceSelect
                allowUpdate
                height='45px'
                options={this.props.reviewDeckOptions}
                value={this.props.deckId || AppUI.defaultReviewDeckId}
                onChange={val => this.props.onSetDeckId(val)}
              />
              <Text
                fontSize='12px'
                bold
                margin='10px 0 0 0'
                color='#333'
              >
                Card Type
              </Text>
              <InPlaceSelect
                allowUpdate
                height='45px'
                options={this.props.cardTypeOptions}
                value={this.props.cardTypeId}
                onChange={val => this.props.onSetCardTypeId(val)}
              />
              <Button
                margin='10px 0 10px 0'
                onClick={this.props.onCreateReviews}
                disabled={this.props.deckButtonDisabled}
                background={Theme.blue}
              >
                <i className='fa fa-plus'/>
                Add to Reviews
              </Button>
              {
                this.props.selectedWordsExcludedFromGenderTrainer && this.props.cardTypeId === Constants.REVIEW_CARD_TYPES.find(item => item.slug === 'gender')?.id &&
                <Alert
                  textAlign='center'
                  width='100%'
                >
                  Some nouns cannot be added as gender cards
                  (<i>{this.props.selectedWordsExcludedFromGenderTrainer.join(', ')}</i>).
                </Alert>
              }
              {
                this.props.selectedWordsExcludedFromPluralTrainer && this.props.cardTypeId === Constants.REVIEW_CARD_TYPES.find(item => item.slug === 'plural')?.id &&
                <Alert
                  textAlign='center'
                  width='100%'
                >
                  Some nouns cannot be added as gender cards
                  (<i>{this.props.selectedWordsExcludedFromPluralTrainer.join(', ')}</i>).
                </Alert>
              }
              {
                this.props.selectedWordsExcludedFromConjugationTrainer && this.props.cardTypeId === Constants.REVIEW_CARD_TYPES.find(item => item.slug === 'conjugation')?.id &&
                <Alert
                  textAlign='center'
                  width='100%'
                >
                  Some verbs cannot be added as conjugation cards at the moment
                  (<i>{this.props.selectedWordsExcludedFromConjugationTrainer.join(', ')}</i>).
                </Alert>
              }
            </ReviewOptionsWrapper>
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(AddToReviews);
